<template>
  <span
    class="exercise-green"
    :class="{
      'exercise-red': !log
    }"
  >
    {{ log ? 'Yes' : 'No' }}
  </span>
</template>

<script>
export default {
  name: "ExerciseLogged",
  props: {
    log: {
      type: [Boolean, String],
      required: true
    }
  }
}
</script>

<style scoped>
.exercise-green {
  color: #15b775;
}
.exercise-red {
  color: #fc4b8b;
}
</style>